import { useState, useMemo } from 'react'
import useDebounce from '../use-debounce'
import { filterFilledParams } from '../use-search-params'
import useAddressProviderData from '../../features/account/hooks/use-address-provider-data'

export const useSuggestAddress = (initialKeyword = 'jakarta') => {
  const [suggestKeyword, setSuggestKeyword] = useState(initialKeyword)
  const debounceSuggestKeyword = useDebounce(suggestKeyword, 500)

  const queryParamsSuggest = useMemo(() => {
    return filterFilledParams({ name: debounceSuggestKeyword })
  }, [debounceSuggestKeyword])

  const { data: suggestAddress = [], isLoading: isLoadingSuggestAddress } =
    useAddressProviderData(queryParamsSuggest)

  return useMemo(
    () => ({
      suggestAddress,
      suggestKeyword,
      debounceSuggestKeyword,
      setSuggestKeyword,
      isLoading: isLoadingSuggestAddress,
    }),
    [
      suggestAddress,
      suggestKeyword,
      debounceSuggestKeyword,
      isLoadingSuggestAddress,
    ]
  )
}
